import React, { useState, useEffect } from 'react';
import { Container, Accordion, Icon, Checkbox } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import TextAreaWithCharacterLimit from '../../../inputs/textAreaWithCharacterLimit.js';
import ReactQuill from 'react-quill';

const ReactQuillContent = React.memo(({ modules, message }) => {
  // Avoid unnecessary re-render when center panel state updates
  return (
    <ReactQuill readOnly={true} modules={modules} value={message} className="rich-text-editor" id="share-link-wa" />
  );
});

const MobileTextAreaContent = React.memo(({ message, onChange, characterLimit, errorMsg, backdropId, tabIndex }) => {
  // Avoid unnecessary re-render when center panel state updates
  return (
    <TextAreaWithCharacterLimit
      message={message}
      onChange={onChange}
      characterLimit={characterLimit}
      errorMsg={errorMsg}
      backdropId={backdropId}
      tabIndex={tabIndex}
    />
  );
});

const EmailTextAreaContent = React.memo(({ message, onChange, characterLimit, errorMsg, backdropId, tabIndex }) => {
  // Avoid unnecessary re-render when center panel state updates
  return (
    <TextAreaWithCharacterLimit
      message={message}
      onChange={onChange}
      characterLimit={characterLimit}
      errorMsg={errorMsg}
      backdropId={backdropId}
      tabIndex={tabIndex}
    />
  );
});

const CenterPanel = (props) => {
  const [settingAccordion, setSettingAccordion] = useState(-1);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = settingAccordion === index ? -1 : index;
    setSettingAccordion(newIndex);
  };

  const getCanEditToggelText = (value) => {
    return value ? 'ON' : 'OFF';
  };

  return (
    <div className="mrbl pdtsss">
      <Container fluid as={Media} greaterThanOrEqual="tablet" className="bold title-sms text-size-l mrtxs mrbs">
        {APP.LANGUAGE.ShareLinkSharedText.Header}
      </Container>
      <Container fluid as={Media} at="tablet" className="bold title-sms text-size-l mrtxs mrbs">
        <hr className="mrtm" style={{ border: '1px solid #e6e6e6' }} />
      </Container>
      <div className="ui form modal-session-bg">
        <Container fluid as={Media} at="mobile" className="round-corner mrbm">
          <Accordion fluid styled id="link-detail-mobile">
            <Accordion.Title
              className="color-white standard-menu-font-size pdtnull pdlnull pdrnull"
              active={settingAccordion === 0}
              index={0}
              onClick={handleClick}
            >
              {APP.LANGUAGE.ShareLinkSharedText.SubHeader}
              {settingAccordion === 0 ? (
                <Icon name="angle up" className="arrow-rotate-up fr text-size-l" />
              ) : (
                <Icon name="angle down" className="arrow-rotate-down fr text-size-l" />
              )}
            </Accordion.Title>
            <Accordion.Content
              className="pdtnull pdlnull pdrnull pdbnull"
              active={settingAccordion === 0}
              content={<ReactQuillContent modules={ReactQuillModules} message={props.originalMessage} />}
            />
          </Accordion>
        </Container>
        <Container fluid as={Media} greaterThanOrEqual="tablet">
          <div className="round-corner mrbm">
            <div className="bold">{APP.LANGUAGE.ShareLinkSharedText.SubHeader}</div>
            <ReactQuillContent modules={ReactQuillModules} message={props.originalMessage} />
          </div>
        </Container>
        {props.updateOrView === 'update' ||
        (props.updateOrView != 'update' &&
          ((props.additionalEmailMessage && props.additionalEmailMessage.trim() != '') ||
            (props.additionalTextMessage && props.additionalTextMessage.trim() != ''))) ? (
          <div className="mrbs title-sms bold">{APP.LANGUAGE.ShareLinkSharedText.SecondHeader}</div>
        ) : (
          ''
        )}
        {props.updateOrView === 'update' ||
        (props.updateOrView != 'update' &&
          props.additionalEmailMessage &&
          props.additionalEmailMessage.trim() != '') ? (
          <Container fluid as={Media} greaterThanOrEqual="computer">
            <div className="title-sms bold mrtnull mrbxs">{APP.LANGUAGE.ShareLinkSharedText.ForEmail}</div>
          </Container>
        ) : (
          ''
        )}
        {props.updateOrView === 'update' ||
        (props.updateOrView != 'update' &&
          props.additionalEmailMessage &&
          props.additionalEmailMessage.trim() != '') ? (
          <Container fluid as={Media} lessThan="computer">
            <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.ShareLinkSharedText.ForEmail}</div>
          </Container>
        ) : (
          ''
        )}
        {props.updateOrView === 'update' ? (
          <EmailTextAreaContent
            message={props.additionalEmailMessage}
            onChange={props.setAdditionalEmailMessage}
            characterLimit={props.emailMessageCharacterLimit}
            errorMsg={props.emailMessageValidState.errorMessage}
            backdropId="backdrop-1"
            tabIndex="2"
          />
        ) : (
          <div className="wrap-link title-sms">{props.additionalEmailMessage}</div>
        )}
        {props.updateOrView === 'update' ||
        (props.updateOrView != 'update' && props.additionalTextMessage && props.additionalTextMessage.trim() != '') ? (
          <Container fluid as={Media} greaterThanOrEqual="computer">
            <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.ShareLinkSharedText.ForText}</div>
          </Container>
        ) : (
          ''
        )}
        {props.updateOrView === 'update' ||
        (props.updateOrView != 'update' && props.additionalTextMessage && props.additionalTextMessage.trim() != '') ? (
          <Container fluid as={Media} lessThan="computer">
            <div className="title-sms bold mrts mrbxs">{APP.LANGUAGE.ShareLinkSharedText.ForText}</div>
          </Container>
        ) : (
          ''
        )}
        {props.updateOrView === 'update' ? (
          <MobileTextAreaContent
            message={props.additionalTextMessage}
            onChange={props.setAdditionalTextMessage}
            characterLimit={props.textMessageCharacterLimit}
            errorMsg={props.textMessageValidState.errorMessage}
            backdropId="backdrop-2"
            tabIndex="3"
          />
        ) : (
          <div className="wrap-link title-sms">{props.additionalTextMessage}</div>
        )}
      </div>
      <Container fluid as={Media} lessThan="computer">
        <hr style={{ border: '1px solid #e6e6e6' }} />
      </Container>
      {props.updateOrView === 'update' ? (
        <div id="no-label-background">
          <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
            <div
              minWidth={window.styleVariable.computerMinWidth}
              className="toggle-box"
              id="share-link-toggle-mobile"
              onClick={() => {
                if (!props.lockStaffCanEditFunction) {
                  props.setCanEditMessages(!props.canEditMessages);
                }
              }}
            >
              <div className="toggle-text text-size-ms">{getCanEditToggelText(props.canEditMessages)}</div>
              <Checkbox toggle disabled={props.lockStaffCanEditFunction} checked={props.canEditMessages} tabIndex="1" />
            </div>
            <div className="ui basic label no-bold borderless pdtsss pdbxxs pdrnull txt-left" data-show="true">
              <h4>{APP.LANGUAGE.ShareLinkSharedText.CanEditMsg}</h4>
            </div>
          </div>
          <div className="display-flex" id="deactive-caption" data-show={props.lockStaffCanEditFunction}>
            <div className="toggle-box-space" />
            <div className="ui basic label no-bold borderless pdtsss pdbxxs pdrnull" data-show="true">
              {APP.LANGUAGE.WaitingAreaShareLink.CanEditMsgDeactivationCaption}
            </div>
          </div>
        </div>
      ) : (
        <div id="no-label-background">
          <div
            className="ui labeled button arrow-pointer display-flex center-flex mrts"
            id="device-enable-check-session"
          >
            <div className="toggle-box" id="share-link-toggle-mobile">
              <div className="toggle-text text-size-ms">{getCanEditToggelText(props.canEditMessages)}</div>
              <Checkbox toggle disabled={true} checked={props.canEditMessages} tabIndex="1" />
            </div>
            <div className="ui basic label no-bold borderless pdtsss pdbxxs pdrnull txt-left" data-show="true">
              <h4>{APP.LANGUAGE.ShareLinkSharedText.CanEditMsg}</h4>
            </div>
          </div>
          <div className="display-flex arrow-pointer" id="deactive-caption" data-show={props.lockStaffCanEditFunction}>
            <div className="toggle-box-space" />
            <div className="ui basic label no-bold borderless pdtsss pdbxxs pdrnull" data-show="true">
              {APP.LANGUAGE.WaitingAreaShareLink.CanEditMsgDeactivationCaption}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CenterPanel;

const ReactQuillModules = {
  toolbar: false, // Hide the toolbar
};
